
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import DialogDetail from './components/DialogDetail.vue';
import { getApplyStockInoutList, getStockInoutTypeList } from '@/api/stock';

@Component({
  name: 'StockInout',
  components: {
    DialogImgLarge,
    DialogDetail
  }
})
export default class extends Vue {
  private formSearch:any = {
    orderdate: '',
    name: '',
    model: '',
    serial: '',
    specification: '',
    select: '',
    type: '',
    typeId: ''
  }
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private typeOptions:any = [{
    value: '1',
    label: '员工入库',
    children: [{
      value: 0,
      label: '全部'
    }]
  }, {
    value: '2',
    label: '员工出库',
    children: [{
      value: 0,
      label: '全部'
    }]
  }]

  private tableData:any = []
  private dialogDetailVisible = false
  private showCustomerSearch = false

  // 公司是否开启新版备件（开启后表格"名称"列显示为"大类/名称"，内容为 parts_name/c_parts_name）
  get isNewSpareParts() {
    const company: any = UserModule.getCompany;
    return !!(company && company.is_new_spare_parts && parseInt(company.is_new_spare_parts) === 1);
  }

  created() {
    this.getList();
  }
  private handlePageSizeChange(val:any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val:any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  private search() {
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      orderdate: '',
      name: '',
      model: '',
      serial: '',
      specification: '',
      select: '',
      type: '',
      typeId: ''
    };
    this.getList();
  }
  private cascaderChange(val:any) {
    this.getStockInoutTypeList(val[0]);
  }
  private cascaderSelect(val:any) {
    this.formSearch.type = val[0];
    this.formSearch.typeId = val[1];
  }
  private getStockInoutTypeList(type:any) {
    let _ = this;
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.type = type;
    pamars.source_type = '5';
    getStockInoutTypeList(pamars).then((res:any) => {
      if (res.data && res.data.list) {
        if (parseInt(type) === 1) {
          _.typeOptions[0].children = [{
            value: 0,
            label: '全部'
          }];
          res.data.list.map(function(item:any) {
            _.typeOptions[0].children.push({
              value: item.id,
              label: item.name
            });
          });
        }
        if (parseInt(type) === 2) {
          _.typeOptions[1].children = [{
            value: 0,
            label: '全部'
          }];
          res.data.list.map(function(item:any) {
            _.typeOptions[1].children.push({
              value: item.id,
              label: item.name
            });
          });
        }
      }
    });
  }

  private getList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    pamars.is_apply_user = 2;
    // 日期
    pamars.apply_date_time = this.formSearch.orderdate ? this.formSearch.orderdate.toString().substring(0, 10) : '';
    // 名称
    pamars.parts_name = this.formSearch.name;
    // 型号
    pamars.parts_model_name = this.formSearch.model;
    // 编号
    pamars.parts_serial_number = this.formSearch.serial;
    // 规格
    pamars.parts_specification = this.formSearch.specification;
    // 类型
    pamars.inout_type = this.formSearch.type;
    pamars.inout_type_id = this.formSearch.typeId;

    getApplyStockInoutList(pamars).then(res => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0
        this.tableData = [];
      }
    }).catch((error) => {
      this.pagination.total = 0
      this.tableData = [];
      let msg = error.msg;
    });
  }

  private getState(val:any) {
    // 1 已提交 3 已拒绝 5 已通过 7已退还 9 已收到
    let str = '';
    switch (parseInt(val.state)) {
      case 1:
        str = '已提交';
        break;
      case 3:
        str = '已拒绝';
        break;
      case 5:
        str = '已通过';
        break;
      case 7:
        str = '已退还';
        break;
      case 9:
        str = '已收到';
        break;
    }
    return str;
  }
  private recordDetail: any = {}

  private detailHandle(val:any) {
    this.dialogDetailVisible = true;
    this.recordDetail = val;
  }
  private closeDetail(val:any) {
    this.dialogDetailVisible = val;
  }
  private successApaly() {
    this.dialogDetailVisible = false;
    this.getList();
  }

  private large(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
